import React from 'react';

import { activeOfferShape } from '../../propTypes';

// Components
import { ActiveOfferWrap } from './ActiveOfferWrap';
import { LabelBlock } from './LabelBlock';
import { DetailsBlock } from './DetailsBlock';
import { DescriptionBlock } from './DescriptionBlock';

const ActiveOffer = ({ activeOffer }) => {
  const {
    extraInfo, lableTitle, title, period, accumulators, icon,
    description, amount, amountUnit, btnLink, btnText,
  } = activeOffer;
  return (
    <ActiveOfferWrap extraInfo={extraInfo}>
      <LabelBlock lableTitle={lableTitle} />
      <DetailsBlock {...{ title, period, accumulators, icon }} />
      <DescriptionBlock {...{ description, amount, amountUnit, btnLink, btnText }} />
    </ActiveOfferWrap>
  );
};

ActiveOffer.propTypes = {
  activeOffer: activeOfferShape,
};

export { ActiveOffer };
